import React, { useContext, useMemo } from 'react'
import { UserContext } from '../../context/UserContext'
import { postRejectRegistration } from '../../services/dashboard.service'
import { toast } from 'react-toastify'
import { getApiErrorMessage } from '../../utils/error'

const RejectButton = ({ data, onUpdated = () => {} }) => {
  const { user } = useContext(UserContext)

  const isPermitted = useMemo(() => {
    return ['Master', 'Korwil'].includes(user?.role?.name)
  }, [user])

  const onReject = async () => {
    try {
      await postRejectRegistration(data?.id)
      toast.success('Penolakan sukses')
      onUpdated(data?.id, { korwilApproval: false })
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Gagal menolak pendaftaran'))
    }
  }

  if (!isPermitted) {
    return <></>
  }

  return (
    <button
      disabled={data?.korwilApproval !== null}
      className="btn btn-sm h-8 min-h-0 rounded-lg border-none normal-case text-[13px] font-semibold bg-[#E5484D] text-white hover:bg-[#CC3B40] disabled:bg-subtle disabled:text-muted"
      onClick={(e) => {
        e.stopPropagation()
        onReject()
      }}
    >
      Tolak
    </button>
  )
}

export default RejectButton
